import { render } from "./ProductCategorySection.vue?vue&type=template&id=1fdea8c2"
import script from "./ProductCategorySection.vue?vue&type=script&lang=js"
export * from "./ProductCategorySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__